import { useMutation } from '@tanstack/react-query';

import { ManifestViewData, viewManifestForDeparture } from '~/services/ToursService';

interface ViewManifestVariables {
  tourId: string;
  departureName: string;
}

export function useViewManifest() {
  return useMutation<ManifestViewData, Error, ViewManifestVariables>({
    mutationFn: ({ tourId, departureName }) => viewManifestForDeparture(tourId, departureName),
  });
}
